import { CheckBoxWidget } from '@tableau/widgets';
import React from 'react';

import { Messages } from '~src/codegen/Localize';
import { getExplorableItemDefinition } from '~src/spacesPlatform/contentDefinitionInterfaces/ContentDefinitionsLists';

import { IContentInfo } from '../../models/IContentInfo';
import { CardViewStyles } from './CardViewStyles';
import { useCardZoomPercentage } from './UseCardZoomPercentage';

export interface ContentCardSelectCheckboxProps {
  readonly content: IContentInfo;
  readonly selected?: boolean;
  readonly toggleSelection?: (content: IContentInfo) => void;
  readonly id: string; //id prop for associating label
}

export const ContentCardSelectCheckbox = (props: ContentCardSelectCheckboxProps): JSX.Element => {
  const typeInfo = getExplorableItemDefinition(props.content.contentType);

  const cardZoomPercentage = useCardZoomPercentage();
  const actualCardZoomPercentage = cardZoomPercentage < 1 ? Math.pow(cardZoomPercentage, 4) : cardZoomPercentage;

  return (
    <span className={CardViewStyles.SelectCheckbox} style={{ left: CardViewStyles.SelectCheckBoxLeft * actualCardZoomPercentage, top: CardViewStyles.SelectCheckBoxTop * actualCardZoomPercentage }}>
      {props.toggleSelection &&
        <CheckBoxWidget
          checked={props.selected}
          handleChange={() => props.toggleSelection(props.content)}
          testId="selection-checkbox"
          id={props.id}
          aria-label={Messages.vizportalSelectCheckbox({
            CONTENT_TYPE: typeInfo.singularName(),
            CONTENT_NAME: props.content.name,
          })} // Screen reader Label
        />
      }
    </span>
  );
};
